import { useMediaQuery } from '@mui/material';
import
{
  Container,
  MainContainer,

} from './PrintWrapper.styles';
import { adminExpandedRoutes } from '../../../options/navLinks';


const MainWrapper = ({ children, error, apiMessage, handleBannerClose, activeRoute, clubLogo, disableIndex, dataLoading, hasEliteLicence, hasRezzilPlayerLicence, licences }) =>
{
  const matches = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <>
      <MainContainer>
        {children}
      </MainContainer>
    </>
  );
};

export default MainWrapper;
